import { useEffect, useState } from 'react'

import { api } from '../../lib/api'
import type { VendorRow } from '../../lib/types'

export default function VendorsPage() {
  const [rows, setRows] = useState<VendorRow[]>([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    api.listVendors()
      .then((r) => setRows(r.items))
      .catch(() => {})
      .finally(() => setLoading(false))
  }, [])

  if (loading) return <div className="skeleton" style={{ height: 240 }} />

  return (
    <div style={{ display: 'grid', gap: 16 }}>
      <div className="card">
        <div className="card-head">
          <span className="card-title">Vendors</span>
          <div className="grow" />
          <span className="muted" style={{ fontSize: 12 }}>
            A vendor becomes trusted after 20 documents at a correction rate under 2%
          </span>
        </div>

        {rows.length === 0 ? (
          <div className="empty">
            <div className="empty-title">No vendors yet</div>
            <div>They are created automatically from the invoices you approve.</div>
          </div>
        ) : (
          <div className="table-wrap">
            <table className="data">
              <thead>
                <tr>
                  <th>Vendor</th><th>GSTIN</th>
                  <th className="num">Documents</th>
                  <th className="num">Correction rate</th>
                  <th>Auto-approval</th>
                </tr>
              </thead>
              <tbody>
                {rows.map((vendor) => (
                  <tr key={vendor.id}>
                    <td style={{ fontWeight: 520 }}>{vendor.name}</td>
                    <td className="mono" style={{ fontSize: 12 }}>
                      {vendor.gstin ?? <span className="muted">—</span>}
                    </td>
                    <td className="num">{vendor.doc_count}</td>
                    <td className="num">{(vendor.correction_rate * 100).toFixed(1)}%</td>
                    <td>
                      {vendor.trusted
                        ? <span className="pill pill-ok">eligible</span>
                        : <span className="pill pill-mute">
                            {vendor.doc_count < 20
                              ? `${20 - vendor.doc_count} more docs`
                              : 'rate too high'}
                          </span>}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  )
}
